module.exports = __webpack_public_path__ + "media/mobile-header-global_.43c4bd92.mp4";